import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    inject,
    Input,
    OnInit,
    Output,
    signal,
    ViewChild,
} from "@angular/core";
import { Table } from "../../../s25-table/Table";
import { EventIncludeOption, EventService } from "../../../../services/event.service";
import { jSith } from "../../../../util/jquery-replacement";
import { S25Util } from "../../../../util/s25-util";
import { TypeManagerDecorator } from "../../../../main/type.map.service";
import { S25Datefilter } from "../../../s25-dateformat/s25.datefilter.service";
import { PricingService } from "../../../../services/pricing.service";
import { S25LoadingApi } from "../../../s25-loading/loading.api";
import { Bind } from "../../../../decorators/bind.decorator";
import { S25TableComponent } from "../../../s25-table/s25.table.component";
import { TelemetryService } from "../../../../services/telemetry.service";
import {
    Invoice,
    InvoiceUpdateData,
    LineItem,
    LineItemAdjData,
    lineItemType,
    PrecheckedInvoiceData,
} from "../../../../pojo/Pricing";
import { UserprefService } from "../../../../services/userpref.service";
import { IncludedOccurrencesComponent } from "../../included.occurrences.component";
import { S25PricingStore } from "../../s25.pricing.store";

@TypeManagerDecorator("s25-ng-pricing-set")
@Component({
    selector: "s25-ng-pricing-set",
    template: `@if (initModal) {
        <div>
            <s25-loading-inline [model]="{}"></s25-loading-inline>
            @if (initData) {
                <div>
                    <div class="pricing-set--name-eventType c-margin-top--single">
                        <h2>Name and Event Type</h2>
                        <div class="c-margin-top--single">
                            <label for="pricing-name"
                                >Name
                                <input
                                    class="c-input c-margin-bottom--half c-margin-left--half"
                                    id="pricing-name"
                                    [ngClass]="{ 'error-outline': errorOutline }"
                                    [(ngModel)]="name"
                                    maxlength="80"
                                />
                                <span class="required">*</span>
                            </label>
                            <s25-ng-checkbox
                                [(modelValue)]="includeEventType"
                                [labelId]="'pricingEventType'"
                                [containerClass]="'pricing-set-eventType'"
                                (modelValueChange)="lineItemAdjData().length && lineItemAdjData.set([])"
                                >Include Event Type {{ eventTypeBilled ? "(already billed)" : "" }}</s25-ng-checkbox
                            >
                        </div>
                    </div>
                    @if (requirementTable?.length) {
                        <div class="pricing-set--reqs c-margin-top--single">
                            <s25-simple-collapse
                                [headerText]="
                                    'Requirements (' + numBilledReqs + '/' + requirementTable.length + ' billed)'
                                "
                                [defaultCollapsed]="true"
                            >
                                <s25-ng-table
                                    [dataSource]="reqTableConfig"
                                    [caption]="'Pricing Set Requirements'"
                                    [hasSelect]="true"
                                    [hasSelectAll]="true"
                                    [selected]="selectedReqIds"
                                    (selectedChange)="include($event, 'req')"
                                ></s25-ng-table>
                            </s25-simple-collapse>
                        </div>
                    }
                    @if (rsrvTable?.length) {
                        <div class="pricing-set--occs">
                            <s25-simple-collapse
                                [headerText]="'Occurrences (' + numBilledOccs + '/' + rsrvTable.length + ' billed)'"
                                [defaultCollapsed]="false"
                            >
                                @if (!invoiceWithAllOccs && !invoiceForEdit) {
                                    <div class="bill-by-buttons">
                                        <s25-ng-radio
                                            [modelValue]="occurrenceBillingSelection()"
                                            [name]="'billByType'"
                                            [value]="'list'"
                                            (modelValueChange)="onOccBillingSelectionChange('list')"
                                            >Select From List</s25-ng-radio
                                        >
                                        <s25-ng-radio
                                            [modelValue]="occurrenceBillingSelection()"
                                            [value]="'date'"
                                            [name]="'billByType'"
                                            (modelValueChange)="onOccBillingSelectionChange('date')"
                                            >Bill By Date Range</s25-ng-radio
                                        >
                                        @if (noBilledOccs) {
                                            <s25-ng-radio
                                                [modelValue]="occurrenceBillingSelection()"
                                                [value]="'all'"
                                                [name]="'billByType'"
                                                (modelValueChange)="onOccBillingSelectionChange('all')"
                                                >Include All</s25-ng-radio
                                            >
                                        }
                                    </div>
                                }
                                @if (occurrenceBillingSelection() === "date") {
                                    <included-occurrences
                                        [eventId]="eventId"
                                        [combineRelatedEvents]="combineRelatedEvents"
                                        [selectedInvoice]="invoiceForEdit"
                                        [isDashView]="false"
                                        (updateCreateNewRange)="selectedDateRange = $event"
                                        (navToInvoice)="navToInvoice.emit($event)"
                                    ></included-occurrences>
                                } @else if (occurrenceBillingSelection() === "list") {
                                    @if (invoiceWithAllOccs) {
                                        @let invoiceName = invoiceWithAllOccs.invoiceName;
                                        @let invoiceId = invoiceWithAllOccs.invoiceId;
                                        <div class="cn-alert cn-alert--warning">
                                            <s25-ng-icon
                                                [type]="'warningYield'"
                                                class="c-margin-right--half"
                                            ></s25-ng-icon>
                                            <span
                                                class="c-textButton"
                                                tabindex="0"
                                                (click)="navToInvoice.emit(invoiceId)"
                                                (keydown.enter)="navToInvoice.emit(invoiceId)"
                                                >{{ invoiceName }}</span
                                            ><span
                                                >&nbsp;was created to include all occurrences. Occurrences may only be
                                                billed to one invoice</span
                                            >
                                        </div>
                                    }
                                    <s25-ng-table
                                        [caption]="'Pricing Set Occurrences'"
                                        [dataSource]="occTableConfig"
                                        [hasSelect]="true"
                                        [hasSelectAll]="true"
                                        [selected]="selectedRsrvIds"
                                        [pivotThreshold]="700"
                                        (selectedChange)="include($event, 'rsrv')"
                                    ></s25-ng-table>
                                } @else if (occurrenceBillingSelection() === "all") {
                                    <p class="ngFinePrint c-margin-top--half" tabindex="0">
                                        Select this option to include all occurrences. Any occurrences added to this
                                        event will be automatically billed to this invoice, and no other invoices can
                                        bill occurrences for this event.
                                    </p>
                                }
                            </s25-simple-collapse>
                        </div>
                    }
                    @if (lineItemAdjData().length) {
                        <allocate-line-item-adj
                            [(lineItemAdj)]="lineItemAdjData"
                            [movedItem]="{ newInvoiceName: name, eventTypeMessage: !includeEventType }"
                        ></allocate-line-item-adj>
                    }
                    <s25-ng-modal-footer [content]="s25ModalFooter"></s25-ng-modal-footer>
                    <ng-template #s25ModalFooter>
                        <div class="footerContainer">
                            @if (errorMessage) {
                                <div>{{ errorMessage }}</div>
                            }
                            <button
                                #submitButton
                                class="aw-button aw-button--primary c-margin-top--single c-margin-bottom--single"
                                (click)="createPricingSet()"
                                [disabled]="isCreatingPricingSet"
                            >
                                {{ isCreatingPricingSet ? "" : (invoiceForEdit ? "Update" : "Create") + " Invoice" }}
                                <s25-loading-inline [model]="{}"></s25-loading-inline>
                            </button>
                        </div>
                    </ng-template>
                </div>
            }
        </div>
    }`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class S25PricingSetComponent implements OnInit {
    @Input() modelBean: any;
    @Input() eventId: number;
    @Input() combineRelatedEvents: boolean;
    @Input() preCheckedData: PrecheckedInvoiceData;

    @Output() close = new EventEmitter<void>();
    @Output() navToInvoice = new EventEmitter<number>();

    @ViewChild("submitButton") submitButton: ElementRef;
    @ViewChild(S25TableComponent) occTable: S25TableComponent;
    @ViewChild(IncludedOccurrencesComponent) includedOccs: IncludedOccurrencesComponent;

    pricingStore = inject(S25PricingStore);
    initModal: boolean;
    initData: boolean;
    includeEventType: boolean = false;
    eventTypeBilled: boolean = false;
    requirementTable: any[];
    rsrvTable: any[];
    occTableConfig: Table.DataSource;
    reqTableConfig: Table.DataSource;
    multiProfiles: boolean;
    name: string;
    isCreatingPricingSet: boolean = false;
    errorMessage: string;
    errorOutline: boolean;
    selectedDateRange: {
        start: Date;
        end: Date;
    };
    selectedRsrvIds: Set<number | string> = new Set();
    selectedReqIds: Set<number | string> = new Set();
    numBilledOccs: number = 0;
    numBilledReqs: number = 0;
    occurrenceBillingSelection = signal<"list" | "date" | "all">("list");
    dateFormat: string;
    allInvoices = this.pricingStore.invoices;
    invoiceWithAllOccs: { invoiceName: string; invoiceId: number };
    noBilledOccs: boolean = true;
    invoiceForEdit: Invoice;
    lineItemAdjData = signal<LineItemAdjData[]>([]);

    occTableColumns: Table.Column[] = [
        { id: "alreadyBilled", header: "Already Billed" },
        { id: "name", header: "Name" },
        { id: "title", header: "Title" },
        { id: "start", header: "Start" },
        { id: "end", header: "End" },
        { id: "comment", header: "Comment" },
        { id: "locations", header: "Locations" },
        { id: "resources", header: "Resources" },
    ];

    reqTableColumns: Table.Column[] = [
        { id: "isBilled", header: "Already Billed" },
        { id: "reqName", header: "Name" },
    ];

    constructor(
        private elementRef: ElementRef,
        private cd: ChangeDetectorRef,
    ) {}

    async ngOnInit() {
        this.initModal = true;
        this.cd.detectChanges();
        S25LoadingApi.init(this.elementRef.nativeElement);

        const includes: EventIncludeOption[] = ["profile", "reservations", "requirements"];
        const [eventData, dateFormat] = await Promise.all([
            this.combineRelatedEvents
                ? EventService.getEventAndRelated(this.modelBean.pricingSet.itemId, includes)
                : EventService.getEventsInclude(this.modelBean.pricingSet.itemId, includes),
            UserprefService.getS25Dateformat(),
        ]);
        this.dateFormat = dateFormat;

        this.setPrecheckedData();

        let rsrvTable: any[] = [],
            requirementTable: any[] = [];

        this.multiProfiles = false;

        const pricingSetRsrvMap: { [key: number]: Set<string> } = {},
            pricingSetReqMap: { [key: number]: Set<string> } = {};

        jSith.forEach(this.allInvoices(), (_, pricingSet) => {
            const preSelectIds =
                this.occurrenceBillingSelection() === "list" && this.invoiceForEdit?.id === pricingSet.id;
            if (pricingSet.billDefn.startDt?.slice(0, 4) === "1900") {
                // startDt with year 1900 indicates all occurrences are included in the invoice
                this.invoiceWithAllOccs = { invoiceName: pricingSet.billDefn.billName, invoiceId: pricingSet.id };
            }
            pricingSet?.billing?.lineItems.forEach((lineItem: LineItem) => {
                if (!!lineItem.occurrences && lineItem.occurrences.length && lineItem.itemType !== lineItemType.EVENT) {
                    this.noBilledOccs = false;
                    lineItem.occurrences.forEach((occurrence) => {
                        const rsrvId = occurrence.rsrvId;
                        preSelectIds &&
                            this.selectedRsrvIds.add(
                                this.combineRelatedEvents ? `${rsrvId}-${lineItem.eventId}` : rsrvId,
                            );
                        if (!pricingSetRsrvMap[rsrvId]) pricingSetRsrvMap[rsrvId] = new Set();
                        pricingSetRsrvMap[rsrvId].add(pricingSet.billDefn.billName);
                    });
                } else if (lineItem.itemType === lineItemType.REQUIREMENT) {
                    const reqId = lineItem.itemId;
                    preSelectIds &&
                        this.selectedReqIds.add(this.combineRelatedEvents ? `${reqId}-${lineItem.eventId}` : reqId);
                    if (!pricingSetReqMap[reqId]) pricingSetReqMap[reqId] = new Set();
                    pricingSetReqMap[reqId].add(pricingSet.billDefn.billName);
                }
            });

            this.eventTypeBilled ||= S25Util.toBool(pricingSet.billDefn.includeEventType);
        });

        jSith.forEach(eventData, (_, event) => {
            const eventId = parseInt(event.event_id),
                eventLocator = event.event_locator,
                eventName = event.event_name,
                eventTitle = event.event_title ?? "";

            this.multiProfiles ||= event.profile?.length > 1;

            jSith.forEach(event.profile, (_, profile) => {
                const profileId = parseInt(profile.profile_id),
                    profileName = S25Util.profileName(profile.profile_name?.toString()) ?? "",
                    profileComment = profile.profile_comments ?? "";

                jSith.forEach(profile.reservation, (_, rsrv) => {
                    const rsrvId = parseInt(rsrv.reservation_id),
                        isBilled = !!pricingSetRsrvMap[rsrvId],
                        rsrvStartDate = S25Datefilter.transform(
                            rsrv.reservation_start_dt,
                            this.modelBean.dateTimeFormat,
                        ),
                        rsrvEndDate = S25Datefilter.transform(rsrv.reservation_end_dt, this.modelBean.dateTimeFormat),
                        rsrvComment = rsrv.rsrv_comments ?? "";
                    let locations: string[] = [],
                        resources: string[] = [];

                    jSith.forEach(rsrv.space_reservation, (_, spRsrv) => {
                        if (!S25Util.isPrivate(spRsrv.space?.space_name)) locations.push(spRsrv.space.space_name);
                    });

                    jSith.forEach(rsrv.resource_reservation, (_, rsRsrv) => {
                        if (!S25Util.isPrivate(rsRsrv.resource?.resource_name))
                            resources.push(rsRsrv.resource.resource_name);
                    });

                    locations = S25Util.array.unique(locations);
                    resources = S25Util.array.unique(resources);

                    rsrvTable.push({
                        eventId,
                        profileId,
                        rsrvId,
                        isBilled: isBilled ? "Yes" : "No",
                        eventLocator,
                        eventName,
                        eventTitle,
                        profileName,
                        profileComment,
                        rsrvStartDate,
                        rsrvEndDate,
                        rsrvComment,
                        locations: locations.join(", "),
                        resources: resources.join(", "),
                        included: this.selectedRsrvIds.has(this.combineRelatedEvents ? `${rsrvId}-${eventId}` : rsrvId),
                    });
                });
            });
            this.numBilledOccs = Object.values(pricingSetRsrvMap).reduce((sum, occ) => sum + occ.size, 0);

            jSith.forEach(event.requirement, (_, requirement) => {
                const reqId = parseInt(requirement.requirement_id),
                    isBilled = !!pricingSetReqMap[reqId];
                requirementTable.push({
                    isBilled: isBilled ? "Yes" : "No",
                    eventId,
                    eventLocator,
                    requirementId: reqId,
                    uuid: `${eventId}&${reqId}`,
                    requirementName: requirement.requirement_name,
                    requirementCount: requirement.requirement_count,
                    requirementComment: requirement.req_comment,
                    included: this.selectedReqIds.has(this.combineRelatedEvents ? `${reqId}-${eventId}` : reqId),
                });
            });
            this.numBilledReqs = Object.values(pricingSetReqMap).reduce((sum, req) => sum + req.size, 0);
        });

        this.rsrvTable = rsrvTable;
        this.requirementTable = requirementTable;

        this.initTableConfigs();

        this.initData = true;
        S25LoadingApi.destroy(this.elementRef.nativeElement);
        this.cd.detectChanges();
    }

    initTableConfigs() {
        if (this.combineRelatedEvents) {
            this.occTableColumns.splice(1, 0, { id: "ref", header: "Reference" });
            this.reqTableColumns.splice(1, 0, { id: "ref", header: "Reference" });
        }

        if (this.multiProfiles) {
            this.occTableColumns.splice(
                this.combineRelatedEvents ? 4 : 3,
                0,
                { id: "segment", header: "Segment" },
                { id: "segComment", header: "Segment Comment" },
            );
        }
        this.occTableConfig = {
            type: "unpaginated",
            dataSource: () => Promise.resolve({ rows: this.rsrvTable.map(this.rsrvMapToRow) }),
            columns: this.occTableColumns,
        };
        this.reqTableConfig = {
            type: "unpaginated",
            dataSource: () => Promise.resolve({ rows: this.requirementTable.map(this.reqMapToRow) }),
            columns: this.reqTableColumns,
        };
    }

    @Bind
    rsrvMapToRow(rsrv: any): Table.Row {
        return {
            id: this.combineRelatedEvents ? `${rsrv.rsrvId}-${rsrv.eventId}` : rsrv.rsrvId,
            name: rsrv.eventName,
            selectable: rsrv.isBilled === "No" || rsrv.included,
            cells: {
                alreadyBilled: { text: rsrv.isBilled },
                ...(this.combineRelatedEvents && { ref: { text: rsrv.eventLocator } }),
                name: { text: rsrv.eventName },
                title: { text: rsrv.eventTitle },
                ...(this.multiProfiles && { segment: { text: rsrv.profileName } }),
                ...(this.multiProfiles && { segComment: { text: rsrv.profileComment } }),
                start: { text: rsrv.rsrvStartDate },
                end: { text: rsrv.rsrvEndDate },
                comment: { text: rsrv.rsrvComment },
                locations: { text: rsrv.locations },
                resources: { text: rsrv.resources },
            },
        };
    }

    @Bind
    reqMapToRow(req: any): Table.Row {
        return {
            id: this.combineRelatedEvents ? `${req.requirementId}-${req.eventId}` : req.requirementId,
            name: req.requirementName,
            cells: {
                isBilled: { text: req.isBilled },
                ...(this.combineRelatedEvents && { ref: { text: req.eventLocator } }),
                reqName: { text: req.requirementName },
            },
        };
    }

    async createPricingSet() {
        if (!this.name) {
            this.errorMessage = "Please enter a name for this invoice";
            this.errorOutline = true;
            this.cd.detectChanges();
            return;
        }
        this.errorOutline &&= false;
        this.errorMessage = "";

        if (this.occurrenceBillingSelection() === "date" && !this.includedOccs.validateDates()) return;

        const included = this.rsrvTable?.filter((rsrv) => rsrv.included);

        let eventIds = included.map((res) => res.eventId) ?? [];

        const rsrvIds = S25Util.array.unique(included.map((res) => res.rsrvId));

        const includedReq = this.requirementTable?.filter((req) => req.included);

        eventIds = eventIds.concat(includedReq.map((req) => req.eventId));

        const reqIds = S25Util.array.unique(includedReq.map((req) => req.requirementId));

        if (
            !this.invoiceForEdit &&
            this.preCheckedData &&
            this.occurrenceBillingSelection() === "list" &&
            !this.lineItemAdjData().length &&
            this.hasLineItemAdjustments(reqIds, rsrvIds)
        )
            return;
        eventIds = S25Util.array.unique(eventIds);

        if (!eventIds.length) {
            eventIds = S25Util.array.unique(this.rsrvTable?.map((rsrv) => rsrv.eventId));

            if (!eventIds.length) {
                this.errorMessage = "No events present";
                this.cd.detectChanges();
                return;
            }
        }

        this.isCreatingPricingSet = true;
        this.cd.detectChanges();
        S25LoadingApi.init(this.submitButton.nativeElement);
        if (this.occurrenceBillingSelection() !== "list") {
            const { start, end } = this.selectedDateRange;
            this.selectedDateRange = {
                start: S25Util.date.toStartOfDay(start),
                end: S25Util.date.toEndOfDay(end),
            };
        }
        try {
            if (this.invoiceForEdit) {
                const hasOccurrences = !!rsrvIds?.length,
                    hasReqs = !!reqIds?.length,
                    nameChanged = this.invoiceForEdit.billDefn.billName !== this.name,
                    payload: Partial<InvoiceUpdateData> = {
                        eventIdList: eventIds,
                        ...(nameChanged && { billName: this.name }),
                        ...(!!this.selectedDateRange
                            ? {
                                  startDt: this.selectedDateRange.start,
                                  endDt: this.selectedDateRange.end,
                              }
                            : {
                                  emptyRsrvList: !hasOccurrences,
                                  ...(hasOccurrences && { rsrvIdList: rsrvIds }),
                                  includeResources: hasOccurrences,
                                  includeSpaces: hasOccurrences,
                              }),
                        includeRequirements: hasReqs,
                        includeEventType: this.includeEventType,
                        ...(hasReqs && { requirementIdList: reqIds }),
                    };
                await PricingService.putBillingCustom(payload, this.invoiceForEdit.id);
            } else {
                TelemetryService.sendWithSub("Pricing", "Event", "CreateSet");
                let promiseArr: Promise<any>[] = [
                    PricingService.postBillingCustom(
                        this.name,
                        eventIds,
                        rsrvIds,
                        reqIds,
                        this.includeEventType.toString(),
                        this.occurrenceBillingSelection() !== "list" && {
                            ...this.selectedDateRange,
                        },
                    ),
                ];

                const preCheckedOcc = this.preCheckedData?.find((item) => item.itemType === "rsrv"),
                    preCheckOccIncluded = rsrvIds.includes(preCheckedOcc?.itemId);
                if (this.occurrenceBillingSelection() === "list" && !!preCheckedOcc && preCheckOccIncluded) {
                    const { itemId, itemType, evBillId } = preCheckedOcc;
                    promiseArr.push(
                        PricingService.putMultiInvoices([
                            PricingService.getRemoveObjData(evBillId, itemId, itemType, this.pricingStore),
                        ]),
                    );
                }
                const [response] = await Promise.all(promiseArr);
                this.modelBean.chosenPricingSet = response?.content?.data?.items[0];
                if (this.modelBean.chosenPricingSet.id && this.lineItemAdjData().length) {
                    await PricingService.putLineItemAdjustments(
                        this.lineItemAdjData()
                            .flatMap((adj) => adj.newAdjustments)
                            .map((adj) => {
                                if (S25Util.isUndefined(adj.billId))
                                    return {
                                        ...adj,
                                        billId: this.modelBean.chosenPricingSet.id,
                                        adjustmentPct: adj.adjustmentPercent,
                                    };
                                return { ...adj, adjustmentPct: adj.adjustmentPercent };
                            }) as LineItem[],
                    );
                }
            }

            this.modelBean.selectPricingSet();
            this.isCreatingPricingSet = false;

            this.close.emit();
        } catch (error) {
            this.errorMessage = S25Util.errorText(error);
            this.isCreatingPricingSet = false;
            this.cd.detectChanges();
            S25LoadingApi.destroy(this.submitButton.nativeElement);
        }
    }

    include(rsrvIds: Set<number | string>, table: "rsrv" | "req") {
        !!this.lineItemAdjData().length && this.lineItemAdjData.set([]);
        const ids = Array.from(rsrvIds),
            tableType = table === "rsrv" ? "rsrvTable" : "requirementTable",
            idProp = table === "rsrv" ? "rsrvId" : "requirementId";

        this[tableType].forEach((obj: any) => {
            const selected = ids.find((id: number | string) => {
                if (typeof id === "string") {
                    // multiple events - extract eventId as well as propId
                    const objEventIdPair = id.split("-"),
                        objId = parseInt(objEventIdPair[0]),
                        eventId = parseInt(objEventIdPair[1]);

                    return obj[idProp] === objId && obj.eventId === eventId;
                }

                return obj[idProp] === id;
            });

            obj.included = !!selected;
        });
    }

    setPrecheckedData() {
        if (this.preCheckedData?.length) {
            this.preCheckedData.forEach((item) => {
                const { itemId, itemType, isInvoiceUpdate } = item;
                if (isInvoiceUpdate) this.setInvoiceEditData(itemId);
                else {
                    this.includeEventType ||= itemType === lineItemType.EVENT;
                    if (itemType === "rsrv") this.selectedRsrvIds.add(itemId);
                    else if (itemType === lineItemType.REQUIREMENT) this.selectedReqIds.add(itemId);
                }
            });
        }
    }

    setInvoiceEditData(invoiceId: number) {
        this.invoiceForEdit = this.allInvoices().find((invoice) => invoice.id === invoiceId);
        const isDateRange = this.invoiceForEdit?.billDefn.startDt && this.invoiceForEdit?.billDefn.endDt;
        if (isDateRange)
            this.selectedDateRange = {
                start: new Date(this.invoiceForEdit.billDefn.startDt),
                end: new Date(this.invoiceForEdit.billDefn.endDt),
            };
        this.occurrenceBillingSelection.set(isDateRange ? "date" : "list");
        this.name = this.invoiceForEdit?.billDefn.billName ?? "";
        this.includeEventType = this.invoiceForEdit?.billDefn.includeEventType ?? false;
    }

    onOccBillingSelectionChange(selection: "list" | "date" | "all") {
        if (selection === "list") {
            this.selectedDateRange = null;
        } else if (selection === "date") {
            this.selectedDateRange = { start: new Date(), end: new Date() };
        } else if (selection === "all") {
            //set date range to include all occurrences for the event, mimicking Standard Pricing
            this.selectedDateRange = {
                start: new Date("1/1/1900"),
                end: new Date("1/1/2100"),
            };
        }
        this.occurrenceBillingSelection.set(selection);
    }

    hasLineItemAdjustments(reqIds: number[], rsrvIds: number[]) {
        const adjustments =
            this.pricingStore
                .invoiceSummaryData()
                .find((invoice) => invoice.id === this.preCheckedData?.[0]?.evBillId)
                ?.lineItemAdjustments?.filter((item) =>
                    item.itemType === lineItemType.REQUIREMENT
                        ? reqIds.includes(item.itemId)
                        : (item.itemType !== lineItemType.EVENT || this.includeEventType) &&
                          rsrvIds.some((id) => item.rsrvIds.has(id)),
                ) ?? [];
        if (adjustments.length) {
            this.lineItemAdjData.set(adjustments);
        }
        return !!adjustments.length;
    }
}
